import MemberTabBase from "@/views/MGT/member/components/member-tab-base.vue";
import { memberDetail, updateMember } from "@/service/structure.js";
import { rsa, encrypt } from "@/libs/rsa.js";
export default {
  name: "member-add",
  components: {
    MemberTabBase
  },
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      }
    },
    row: {
      type: Object,
      default() {
        return {};
      }
    },
    node: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      styles: {
        height: "calc(100% - 50px)",
        overflow: "scroll",
        paddingBottom: "40px",
        position: "static"
      },
      loading: false,
      member: {}
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    isMobile() {
      return window.innerWidth < 768;
    },
    _IdName() {
      if (this.$store.state.user.gig) {
        return this.member.userCode ? `（ID：${this.member.userCode}）` : "";
      } else {
        return `（ID：${this.member.userId}）`;
      }
    },
    _statusName() {
      let statusObj = {
        10: $t("fj1g2", "在职"),
        // lg: 在职
        50: $t("lb5z2", "禁用"),
        // lg: 禁用
        99: $t("ler52", "离职") // lg: 离职
      };
      return statusObj[this.member.status];
    },
    isAdmin() {
      return this.$store.state.user.userInfo.isAdmin === "T";
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.getDetail();
      }
    }
  },
  methods: {
    close() {
      this.member = {};
      this.visible = false;
    },
    scrollToTop(visible) {
      if (visible) {
        setTimeout(() => {
          const drawer = document.querySelector(".member_detail .ivu-drawer-body");
          if (drawer) {
            drawer.scrollTop = 0;
          }
        }, 100);
      }
    },
    async getDetail() {
      const params = {
        userId: this.row.userId
      };
      let {
        data
      } = await memberDetail(params);
      if (data && data.result === 0) {
        this.member = data.retVal;
      }
    },
    async onSubmit() {
      let res = await this.$refs["memberTabBaseRef"].validate();
      let form = res.form;
      let passwordValid = res.passwordValid;
      res.validate(async valid => {
        if (valid) {
          let params = {
            ...form,
            userId: this.row.userId
          };
          if (form.interfaceOnly === "T") {
            if (!passwordValid) {
              return;
            }
            params.userEmail = "";
            params.userMobile = "";
            params.password = encrypt(form.password);
          } else {
            params.password = "";
            const {
              userEmail,
              userMobile,
              userCode
            } = form;
            if (!userEmail && !userMobile) {
              // lg: 手机号和邮箱不能同时为空
              this.$Message.error($t("2rqjy7c", "手机号和邮箱不能同时为空"));
              return;
            }
            if (this.member.userCode !== "ADMIN" && userCode === "ADMIN") {
              // lg: 用户代码不能填写ADMIN
              this.$Message.error($t("2eoz38d", "用户代码不能填写ADMIN"));
              return;
            }
            let resRsa = rsa(form, ["userMobile", "userEmail"]);
            params = {
              ...params,
              ...resRsa
            };
          }
          this.loading = true;
          let {
            data
          } = await updateMember(params);
          this.loading = false;
          if (data && data.result === 0) {
            // lg: 保存成功
            this.$Message.success($t("aghf564", "保存成功"));
            this.$emit("onSuccess");
            this.close();
          }
        }
      });
    }
  }
};